export const UNIVERSAL_PIXEL_INSTRUCTION = (
  <>
    <p>
      Place the Universal Site Pixel (USP) inside
      the global {'<head>'} element of your site so it
      loads unconditionally on every page. The USP must load
      first across your site before any additional functions are
      triggered.
    </p>
    <p>
      If you&#39;re using a Tag Manager, add the
      USP as a Custom HTML tag and set it to
      trigger on All Pages.
    </p>
  </>
)

export const PAGE_VISIT_INSTRUCTION = (
  <>
    <p>
      Place the Page Visit Pixel within the
      {' <body>'} element on every page. Ensure this function
      loads after the USP and as early as
      possible in the page load for the most accurate tracking.
    </p>
    <p>
      If you&#39;re using a Tag Manager, Add the
      Visited Website tag as a Custom HTML tag,
      and configure it to fire after the USP.
      In Google Tag Manager, you can use the
       Tag Sequencing feature to ensure it only
      runs after the USP tag has successfully fired.
    </p>
  </>
)

export const CUSTOM_EVENT_INSTRUCTION = (
  <>
    <p>
      Copy the code snippet and replace the values inside  <br />
      <span style={{ color: '#f30000' }}>{' {{double curly brackets}} '}</span>
      with your dynamic variables. You may remove any optional lines if you
      don’t intend to pass those values. Place the finalized script within
      the {'<body>'} of the event confirmation page or attach it to the
      appropriate HTML element for inline triggering.
    </p>
    <p>
      If you&#39;re using a Tag Manager, add the Pixel as a Custom HTML tag and
      configure it to trigger after the Universal Site Pixel (USP). In Google
      Tag Manager, use Tag Sequencing to ensure it only fires once the USP has
      loaded successfully.
    </p>
    <p>
      For additional parameters, please refer to our{' '}
      <a
        href="https://help.tvscientific.app/en/articles/11107787-tvscientific-pixels-overview"
        target="_blank"
        rel="noopener noreferrer"
      >
      documentation portal
      </a>
      {' '}or contact our integration team.
    </p>
  </>
)
